export interface Flow {
    type: string;
    tagName: string;
    informationOrQuestion: string;
    issueId: string;
    notes: string;
    controls: Control[];
    targetId: number;
    imagesOrVideos: string[];
    lastModifiedDate: Date;
    featureType: string;
    isLastStep: boolean;
    hasContentSpliter: boolean;
    phoneCompatibilty: PhoneCompatibility;
    documents: string[];
    reviewComments: ReviewComments[];
    troubleshoot: Troubleshoot;
    badges: Badges[];
    isControlAsButton: boolean;
    isImageFromS3?: boolean;
    faqs?: FAQ;
    hideProgressBar?: boolean;
}

export interface FAQ {
    faqs: string;
}

// add var in flow interface for both the badges 
export interface Badges {
    badgeName: string;
    link: string;
    image?: string;
}

export interface FeatureFlow {
    type: string;
    tagName: string;
    informationOrQuestion: string;
    issueId: string;
    isGeneric: boolean;
    notes: string;
    controls: Control[];
    targetId: number;
    imagesOrVideos: string[];
    createdBy: string;
    lastModifiedDate: Date;
    lastModifiedBy: string;
    featureType: string;
    isLastStep: boolean;
    hasContentSpliter: boolean;
    phoneCompatibilty: PhoneCompatibility;
    documents: string[];
    status: string;
    publishedDate: Date;
    reviewComments: ReviewComments[];
    troubleshoot: Troubleshoot;
    badges: Badges[];
    isControlAsButton: boolean;
    category: string;
    isImageFromS3?: boolean;
    faqs?: FAQ;
    hideProgressBar?: boolean;
}

export interface draftCategory {
    draftCategory: string;
    draftMessage: string;
}

export interface Troubleshoot {
    troubleshootingSteps: string;
}


export interface ReviewComments {
    reviewComment: string;
    reviewedDate: Date;
    reviewedBy: string;
}
export interface Control {
    featureName: string;
    controlName: string;
    targetId: number;
    controlType: string;
    icon: string;
    status?: string;
    publishedData?: string;
    draftCategory?: draftCategory;
    hideProgressBar?: boolean;

}
export interface PhoneCompatibility {
    linkUrl: string;
    displayName: string;
    icon: string;
}
export interface Troubleshoot {
    troubleshootingSteps: string;
}

export class ImageRequest {
    source: string;
    contentType: string;
    contentBase64: string;
    fileName: string;

}

export class disclaimerRequest {
    source: string;
    contentType: string;
    contentBase64: string;
    fileName: string;
    fileDisplayName: string;
}
export class Step {
    flow: Flow;
    stepType: string = null;
}

export class VideoRequest {
    source: string;
    contentType: string;
    contentBase64: string;
    fileName: string;

}

export interface FeatureStatusUpdate {
    issueId: string[];
    source: string;
    status: string;
    draftCategory: draftCategory;
    firstPublishedDate?: any;
}

export interface FeatureStatusUpdate {
    issueId: string[];
    source: string;
    status: string;
    draftCategory: draftCategory;
    firstPublishedDate?: any;
}

export interface Feature {
    issueId: string;
    source: string;
    featureType: string;
}
